import { createSlice } from '@reduxjs/toolkit'

export const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    value: 0,
    subPage: null,
    subPage2: null
  },
  reducers: {
    setMenuData: (state, action) => {
      state.value += action.payload
    },

    setSubPage: (state, action) => {
      state.subPage = action.payload
    },

    setSubPage2: (state, action) => {
      state.subPage2 = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setMenuData, setSubPage, setSubPage2 } = menuSlice.actions

export default menuSlice.reducer